export const menuItems = [
    {
        id: 1,
        label: "Lancer une enquête",
        icon: "bx-plus",
        link: "student",
        role: "start-quest"
    },
    {
        id: 2,
        label: "Statistiques",
        icon: "bx-bar-chart-alt",
        link: "dashboard",
    },
    {
        id: 4,
        label: "Enquêtes",
        icon: "bx-copy-alt",
        subItems: [
            {
                id: 5,
                label: "Liste des enquêtes",
                link: "surveys",
                parentId: 4,
                role: "view-quest"
            },
            {
                id: 6,
                label: "Liste des questions",
                link: "questions",
                parentId: 4,
                role: "edit-question"
            }
        ]
    },
    {
        id: 19,
        label: "Gestion des stagiaires",
        icon: "bx-user",
        link: "students",
        role: "view-stagiaire"
    },
    {
        id: 4,
        label: "Gestion des données",
        icon: "bx-customize",
        subItems: [
            {
                id: 22,
                label: "Gestion des EFP",
                link: "efp",
                role: "view-efp"
            },
            {
                id: 25,
                label: "Gestion des filieres",
                link: "branchs",
                role: "view-filiere"
            }
        ]
    },
    {
        id: 70,
        icon: "bx-lock-open-alt",
        label: "Gestion des utilisateurs",
        link: "users",
        role: "view-utilisateur"
    },
    {
        id: 80,
        icon: "bx-import",
        label: "Importer",
        link: "import",
        role: "import"
    }
];
